import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import './BedrijfRegistratie.css';

const BedrijfRegistratie = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    bedrijfsnaam: '',
    email: '',
    telefoonnummer: '',
    kvk_nummer: '',
    voornaam: '',
    achternaam: '',
    wachtwoord: '',
    wachtwoord_bevestig: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.wachtwoord !== formData.wachtwoord_bevestig) {
      setError('Wachtwoorden komen niet overeen');
      return;
    }

    if (formData.wachtwoord.length < 6) {
      setError('Wachtwoord moet minimaal 6 tekens zijn');
      return;
    }

    setLoading(true);

    try {
      const response = await api.post('/bedrijven/register', {
        bedrijfsnaam: formData.bedrijfsnaam,
        email: formData.email,
        telefoonnummer: formData.telefoonnummer,
        kvk_nummer: formData.kvk_nummer,
        voornaam: formData.voornaam,
        achternaam: formData.achternaam,
        wachtwoord: formData.wachtwoord
      });

      if (response.data.success) {
        alert(`Welkom bij WOMSYS! Je bedrijf "${response.data.bedrijf.naam}" is geregistreerd met een 14-daagse trial. Je kunt nu inloggen.`);
        navigate('/login');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Er ging iets mis bij de registratie');
      setLoading(false);
    }
  };

  return (
    <div className="registratie-container">
      <div className="registratie-box">
        <div className="registratie-header">
          <h1>Start je 14-daagse gratis trial</h1>
          <p>Geen creditcard nodig • Direct beginnen</p>
        </div>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit} className="registratie-form">
          <div className="form-section">
            <h3>Bedrijfsgegevens</h3>
            
            <div className="form-group">
              <label>Bedrijfsnaam *</label>
              <input type="text" name="bedrijfsnaam" value={formData.bedrijfsnaam} onChange={handleChange} required disabled={loading} placeholder="Jouw Bedrijf B.V." />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>E-mailadres *</label>
                <input type="email" name="email" value={formData.email} onChange={handleChange} required disabled={loading} placeholder="info@bedrijf.nl" />
              </div>
              <div className="form-group">
                <label>Telefoonnummer</label>
                <input type="tel" name="telefoonnummer" value={formData.telefoonnummer} onChange={handleChange} disabled={loading} placeholder="06-12345678" />
              </div>
            </div>

            <div className="form-group">
              <label>KVK nummer</label>
              <input type="text" name="kvk_nummer" value={formData.kvk_nummer} onChange={handleChange} disabled={loading} placeholder="12345678" />
            </div>
          </div>

          <div className="form-section">
            <h3>Jouw gegevens</h3>
            
            <div className="form-row">
              <div className="form-group">
                <label>Voornaam *</label>
                <input type="text" name="voornaam" value={formData.voornaam} onChange={handleChange} required disabled={loading} />
              </div>
              <div className="form-group">
                <label>Achternaam *</label>
                <input type="text" name="achternaam" value={formData.achternaam} onChange={handleChange} required disabled={loading} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Wachtwoord *</label>
                <input type="password" name="wachtwoord" value={formData.wachtwoord} onChange={handleChange} required disabled={loading} minLength="10" placeholder="Min. 10 tekens, hoofdletter, cijfer, speciaal teken" />
              </div>
              <div className="form-group">
                <label>Bevestig wachtwoord *</label>
                <input type="password" name="wachtwoord_bevestig" value={formData.wachtwoord_bevestig} onChange={handleChange} required disabled={loading} minLength="6" />
              </div>
            </div>
          </div>

          <button type="submit" className="btn-registreer" disabled={loading}>
            {loading ? 'Bezig met registreren...' : 'Start gratis trial'}
          </button>

          <p className="login-link">
            Heb je al een account? <a href="/login">Log hier in</a>
          </p>
        </form>

        <div className="trial-info">
          <h4>✓ 14 dagen gratis proberen</h4>
          <ul>
            <li>Geen creditcard nodig</li>
            <li>Direct toegang tot alle functies</li>
            <li>Na trial: vanaf €29/maand</li>
            <li>Opzeggen kan altijd</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default BedrijfRegistratie;
